export enum ActionTypes {
  CREATE = "create",
  JOIN = "join",
  VOTE = "vote",
  GET_SYSTEMS = "systems",
  SET_TOKEN = "set-token",
  USER_CHANGE = "user-change",
  VOTE_CHANGE = "vote-change",
  TIMER_CHANGE = "timer-change",
  VOTE_REVEAL = "vote-reveal",
  NEW_VOTING = "new-voting",
  GAME_SUMMARY = "game-summary",
  TASK_LIST_UPDATE = "task-list-update",
  TASK_UPDATE = "tasks-update",
  REMOVE_TASK = "remove-task",
  TASK_ADD = "task-add"
}
